export default {
    nav: {
        home: 'Главная',
        products: 'Продукты',
        solutions: 'Решения',
        support: 'Поддержка',
        aboutUs: 'О нас',
        contact: 'Контакты'
    },
    hero: {
        title: 'Kooyii Smart<br>Комплексные решения для умных пространств и систем безопасности',
        desc: 'Мы делаем пространства умнее, безопаснее и надежнее.'
    },
    protocol: {
        title: 'Протоколы связи',
        cards: {
            zigbee: 'Zigbee 3.0 — это единый стандарт беспроводной связи, представленный Альянсом по стандартам подключения (CSA). Он обеспечивает бесшовную совместимость устройств разных брендов и создание ячеистых сетей (mesh) с низким энергопотреблением за счет интеграции разрозненных протоколов приложений.',
            wifi: 'Wi-Fi — это всемирно признанная технология беспроводных сетей, передающая данные с помощью радиоволн, позволяя устройствам подключаться к сетям без использования физических кабелей.',
            rf433: '433 МГц — это низкочастотный радиодиапазон, обычно используемый для устройств малого радиуса действия и низкого энергопотребления, таких как системы охранной сигнализации и умные выключатели.',
            modbus: 'Modbus — это протокол последовательной связи, широко используемый в промышленной автоматизации, поддерживающий архитектуру "ведущий-ведомый" и обмен данными.',
            knx: 'KNX — это европейский стандарт шинной технологии, широко используемый в системах автоматизации для умных зданий.',
            bluetooth: 'Bluetooth — это беспроводная технология для обмена данными между устройствами, широко применяемая в умных отелях, умных домах и других сферах.'
        }
    },
    services: {
        title: 'Сценарии применения',
        features: {
            smartHome: {
                title: 'Умный дом',
                desc: 'Разрушьте ограничения традиционных домов, чтобы создать умное жилое пространство для любых сценариев. Поддержка множества протоколов, таких как Zigbee и Wi-Fi, обеспечивает взаимосвязь устройств и плавное переключение сценариев. Откройте для себя высокоэффективный и удобный образ жизни с минималистичным управлением, привнося технологический комфорт в ваш дом.'
            },
            security: {
                title: 'Умная безопасность',
                desc: 'Охранная централь в сочетании с профессиональной платформой мониторинга для создания интегрированной системы безопасности. В качестве ядра системы централь подключается к различным датчикам (инфракрасным, дымовым, кнопкам экстренного вызова) по протоколу 433 МГц, обеспечивая оповещения в реальном времени о вторжениях, пожарах и чрезвычайных ситуациях.'
            },
            hotel: {
                title: 'Умный отель',
                desc: 'Это решение, ориентированное на IoT и объединенное с платформой управления гостиничным оборудованием, связывает умные номера, работу стойки регистрации и обслуживание номеров, обеспечивая двойную выгоду как для гостей, так и для руководства отеля.'
            },
            building: {
                title: 'Автоматизация зданий',
                desc: 'На базе RTU и с настройкой через панель управления, решение поддерживает интеграцию устройств Modbus для легкого достижения централизованного мониторинга, умного управления и управления энергопотреблением оборудования здания, превращая традиционные строения в умные.'
            }
        }
    },
    software: {
        title: 'Программное обеспечение и платформы',
        steps: {
            cms: { title: 'Центр мониторинга', desc: 'Нажмите, чтобы перейти' },
            kooyii: { title: 'Kooyii', desc: 'Наведите курсор, чтобы отсканировать и скачать' },
            elderly: { title: 'Уход за пожилыми', desc: 'Демонстрация пока недоступна. Свяжитесь с отделом продаж для получения деталей.' },
            hotel: { title: 'Умный отель', desc: 'Демонстрация пока недоступна. Свяжитесь с отделом продаж для получения деталей.' },
            building: { title: 'Автоматизация зданий', desc: 'Демонстрация пока недоступна. Свяжитесь с отделом продаж для получения деталей.' },
            more: { title: 'Больше сценариев', desc: 'Пожалуйста, свяжитесь с нашим отделом продаж для профессиональной консультации.' }
        }
    },
    solutions: {
        services: {
            title: 'Наши услуги',
            features: {
                hardware: {
                    title: 'Разработка оборудования (Hardware)',
                    desc: 'Комплексные эксклюзивные услуги по проектированию и производству, от основных плат PCBA до внешнего вида готовых устройств. Включает проектирование схем, выбор компонентов, трассировку печатных плат (PCB), функциональную отладку, изготовление пресс-форм для корпусов, подбор материалов и структурную защиту.'
                },
                software: {
                    title: 'Разработка ПО (Software)',
                    desc: 'Индивидуальная разработка приложений и веб-систем на основе ваших реальных бизнес-потребностей, включая мобильные приложения (iOS/Android), веб-интерфейсы для ПК и управление бэкендом (админ-панели). Мы предоставляем высокоэффективные цифровые решения, адаптированные к вашей операционной модели.'
                },
                server: {
                    title: 'Частное развертывание',
                    desc: 'Развертывание систем, платформ или приложений полностью на ваших собственных серверах или в выделенных сетях интранет. Данные и сервисы работают полностью независимо, обеспечивая полный автономный контроль.'
                }
            }
        },
        whyUs: {
            title: 'Почему выбирают нас?',
            benefits: {
                oneStop: {
                    title: 'Комплексное обслуживание (One-Stop)',
                    desc: 'Наши решения охватывают как программное, так и аппаратное обеспечение с единым согласованием на всех этапах, устраняя необходимость координации между подрядчиками, сокращая циклы разработки и снижая затраты на коммуникацию.'
                },
                custom: {
                    title: 'Глубокая кастомизация',
                    desc: 'Функции программного обеспечения точно оптимизированы под аппаратную производительность, что позволяет избежать проблем совместимости и гарантировать более плавную работу в целом с более низким уровнем отказов.'
                },
                expandable: {
                    title: 'Высокая масштабируемость',
                    desc: 'Наши услуги предусматривают интерфейсы расширения, что облегчает клиентам модернизацию и добавление функциональности в зависимости от будущих потребностей.'
                },
                deployment: {
                    title: 'Гибкое развертывание',
                    desc: 'Будь то локализованное частное развертывание (on-premise) или использование публичного облака, мы предоставляем гибкие решения для удовлетворения ваших потребностей.'
                }
            }
        },
        cta: {
            title: 'Готовы улучшить свой бизнес и образ жизни?',
            desc: 'Свяжитесь с нашими экспертами по умным технологиям уже сегодня, и позвольте нам спроектировать идеальную экосистему для вас.',
            button: 'Связаться с отделом продаж'
        }
    },
    product: {
        nav: {
            panel: 'Панели управления',
            hub: 'Умные шлюзы (Хабы)',
            switch: 'Умные выключатели',
            curtain: 'Умные шторы',
            sensor: 'Датчики',
            lighting: 'Умное освещение',
            security: 'Умная безопасность',
            doorlock: 'Умные замки'
        },
        sub: {
            '4inch': '4 дюйма',
            '5inch': '5 дюймов',
            '6inch': '6 дюймов',
            '7inch': '7 дюймов',
            '8inch': '8 дюймов',
            '10inch': '10 дюймов',
            '1gang': '1 клавиша',
            '2gang': '2 клавиши',
            '3gang': '3 клавиши',
            '4gang': '4 клавиши',
            wireless: 'Беспроводной',
            wired: 'Проводной',
            'openclose': 'Мотор для раздвижных штор',
            'roller': 'Рулонная штора',
            'downlight': 'Точечные светильники',
            'magnetic': 'Магнитные трековые системы',
            'strip': 'Светодиодные ленты',
            'alarm': 'Охранная централь',
            'door': 'Датчик открытия',
            'smoke': 'Датчик дыма',
            'infrared': 'Датчик движения (ИК)',
            'radar': 'Радар присутствия человека',
            'water': 'Датчик протечки воды',
            'temp': 'Датчик темп. и влажности',
            'indoorCam': 'Внутренняя камера',
            'outdoorCam': 'Наружная камера',
            'password': 'Замок с паролем',
            'fingerprint': 'Замок с отпечатком пальца',
            'face': 'Замок с Face ID'
        },
        common: {
            learnMore: 'Узнать больше',
            addToCart: 'В корзину',
            buyNow: 'Купить сейчас',
            emptyProduct: 'Связанных продуктов пока нет. Следите за обновлениями...'
        },
        cart: {
            titleList: 'Список запросов',
            titleForm: 'Заполните контактную информацию',
            empty: 'Ваш список пуст, добавьте товары!',
            delete: 'Удалить',
            totalItems: 'Всего выбрано {count} товаров',
            nextStep: 'Следующий шаг: заполнить информацию',
            submit: 'Отправить запрос'
        },
        form: {
            name: 'Как к вам обращаться?',
            namePlaceholder: 'Пожалуйста, введите ваше имя',
            address: 'Адрес компании',
            addressPlaceholder: 'Пожалуйста, введите подробный адрес вашей компании',
            location: 'Город / Страна',
            locationPlaceholder: 'Например: Москва, Россия',
            whatsapp: 'WhatsApp',
            whatsappPlaceholder: 'Введите ваш WhatsApp, чтобы мы могли с вами связаться',
            email: 'Email',
            emailPlaceholder: 'Введите ваш email, чтобы мы могли с вами связаться',
            remark: 'Примечания',
            remarkPlaceholder: 'Введите любые примечания, чтобы мы лучше поняли ваши потребности'
        },
        alert: {
            fillRequired: 'Пожалуйста, заполните все обязательные поля (отмеченные *)',
            submitSuccess: 'Запрос успешно отправлен! Наша команда продаж свяжется с вами в ближайшее время.'
        }
    },
    contact: {
        hero: {
            title: 'Связаться с нами',
            desc: 'Получите профессиональную консультацию и решения, которые подходят именно вам'
        },
        form: {
            title: 'Отправьте нам сообщение',
            subtitle: 'Заполните форму ниже, и мы ответим вам в течение 24 часов.',
            firstName: 'Имя',
            firstNamePlaceholder: 'Например: Иван',
            lastName: 'Фамилия',
            lastNamePlaceholder: 'Например: Иванов',
            email: 'Рабочий Email',
            emailPlaceholder: "ivan{'@'}company.ru",
            inquiryType: 'Тип запроса',
            selectTopic: 'Выберите тему...',
            message: 'Сообщение',
            messagePlaceholder: 'Чем мы можем вам помочь?',
            submitBtn: 'Отправить сообщение',
            sending: 'Отправка...',
            successMsg: 'Спасибо! Ваше сообщение успешно отправлено.'
        },
        inquiry: {
            general: 'Общие вопросы',
            sales: 'Продажи и дистрибуция',
            support: 'Техническая поддержка',
            hardware: 'OEM/ODM',
        },
        location: {
            title: 'Где мы находимся',
            officeName: 'Штаб-квартира в Шэньчжэне',
            address: 'Комната 603, Подъезд 1, Здание 1, Площадь Кайлифан, Улица Ляньжунь, Округ Таоюань, Район Далан, Район Лунхуа, Шэньчжэнь, Гуандун, Китай',
            phone: '+86 18926403313 Г-жа Юань'
        }
    },
    footer: {
        companyName: 'Shenzhen Golden Security Technology Co., Ltd.'
    }
}